import { Table } from '@vivaldis/antd-ui'
import { useTranslation } from 'react-i18next'
import { EmployeeDetailsQuery_employee_teamCompanies } from '../../../../graphql/__generated__/EmployeeDetailsQuery'
import { Actions } from './components/Actions'
import { Vat } from './components/Vat'
import { Name } from './components/Name'

interface Props {
  teamCompanies: EmployeeDetailsQuery_employee_teamCompanies[]
}

export const CompaniesList = ({ teamCompanies }: Props) => {
  const [t] = useTranslation()

  return (
    <Table<EmployeeDetailsQuery_employee_teamCompanies>
      dataSource={teamCompanies}
      rowKey="id"
      pagination={false}
    >
      <Table.Column<EmployeeDetailsQuery_employee_teamCompanies>
        title={t(
          'screens.employee_details.tabs.companies.table.columns.company_name.title'
        )}
        key="name"
        render={(value, teamCompany) => <Name teamCompany={teamCompany} />}
      />
      <Table.Column<EmployeeDetailsQuery_employee_teamCompanies>
        title={t(
          'screens.employee_details.tabs.companies.table.columns.company_vat.title'
        )}
        key="vat"
        render={(value, teamCompany) => <Vat teamCompany={teamCompany} />}
      />
      <Table.Column<EmployeeDetailsQuery_employee_teamCompanies>
        title={t(
          'screens.employee_details.tabs.companies.table.columns.actions.title'
        )}
        key="actions"
        align="right"
        width={50}
        render={(value, teamCompany) => <Actions teamCompany={teamCompany} />}
      />
    </Table>
  )
}
